module.exports = __webpack_public_path__ + "app/bento-components/blog-river/media/default-image.svg?1b15dca348de74c952cd1ce3302a6d16";